import DeleteGenericModal from "../../modals/DeleteGenericModal";
import ReactTable from "../../util/ReactTable";
import AsyncBlock from "../../components/forms/AsyncBlock";
import PageTitle from "../../components/layout/PageTitle";
import PageSection from "../../components/layout/PageSection";
import Button from "../../components/forms/Button";
import PageContainerFull from "../../components/layout/PageContainerFull";
import {useCallback, useContext, useMemo} from "react";
import {FlexLayout} from "../../components/flex/Flex";
import useDeleteModal from "../../modals/useDeleteModal";
import axios from "axios";
import useFetch2 from "../../hooks/useFetch2";
import {Apis} from "../../util/data";
import {useNavigate} from "react-router-dom";
import {format} from "date-fns";
import * as React from "react";
import {AuthContext} from "../../context/AuthContext";

const HorarioList = () => {

  const navigate = useNavigate()
  const {user} = useContext(AuthContext);
  const {loading, data, fetchData, error} = useFetch2(Apis.PROD + '/horario-atencion/list'+ ((user?.tipoUsuario === 6) ? "/" + user?.id: ""), []);

  const deleteElement = id => axios.delete(Apis.PROD + '/horario-atencion/' + id)

  const formatoFecha = 'dd/MM/yyyy';


  const {
    wrapper: wrapper1,
    openDeleteModal
  } = useDeleteModal({
    text: '¿Desea eliminar este horario?',
    action: deleteElement,
    onRefresh: fetchData
  })

  function addHorario() {
    navigate('/horario/new')
  }

  function editHorario(item) {
    navigate('/horario/edit/' + item.id)
  }

  const fechaValue = useCallback(cell => {
    const fechaUTC = new Date(cell.renderValue() + new Date().getTimezoneOffset() * 60000);
    return format(fechaUTC, formatoFecha)
  }, []);
  const actionsValue = useCallback(cell =>
      <FlexLayout justifyContent='center'>
        <Button size='xs' variant='light' onClick={() => editHorario(cell.row.original)}>Editar</Button>
        <Button size='xs' variant='danger' onClick={() => openDeleteModal(cell.row.original.id)}>Eliminar</Button>
      </FlexLayout>
    // eslint-disable-next-line react-hooks/exhaustive-deps
    , []);

  const columns = useMemo(
    () => [
      {
        header: 'Consejero',
        accessorKey: 'usuario'
      },
      {
        header: 'Fecha inicio',
        accessorKey: 'fechaInicio',
        cell: fechaValue
      },
      {
        header: 'Fecha fin',
        accessorKey: 'fechaFin',
        cell: fechaValue
      },
      {
        header: 'Hora inicio',
        accessorKey: 'horaInicio',
      },
      {
        header: 'Hora fin',
        accessorKey: 'horaFin',
      },
      {
        header: 'Acciones',
        accessorKey: 'id',
        meta: {
          headerClassName: 'text-center', // class para la cabecera
          columnClassName: 'text-center', // class para la columna
        },
        enableSorting: false, // para deshabilitar el sort
        cell: actionsValue
      }
    ]
    // eslint-disable-next-line react-hooks/exhaustive-deps
    , [data]
  )

  return (
    <PageContainerFull>

      <PageSection>
        <PageTitle title={'Horarios'}/>

        <AsyncBlock loading={loading} error={error}>
          <ReactTable
            columns={columns}
            data={data || []}
            customSearch
            filterAdd={() => addHorario()}
            noData='No existen horarios'
            pageSize={20}
          />
        </AsyncBlock>
      </PageSection>
      <DeleteGenericModal {...wrapper1} />
    </PageContainerFull>
  )
}

export default HorarioList
